<template>
  <div class="change-system-content-list-date">
    <LlState
      required
      type="date"
      leading-icon="icon-datestart"
      rules="required"
      :title="$t('到期日')"
      :value="expiredDate"
      @input="selectExpiredDate($event)"
    />
    <ChangeSystemContent
      v-for="(change,changeIndex) in changeList"
      :key="changeIndex"
      border-top
      :title="change.title"
      :icon="change.icon"
      :taker="change.taker"
      :change-list="change.viewList"
      @taker-select="selectChangeTaker($event,changeIndex)"
    />
  </div>
</template>
<script>
export default {
  name: "ChangeSystemContentListDate",
  props: {
    expiredDate: {
      type: String,
      default: "",
    },
    changeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    selectExpiredDate($event) {
      this.$emit("select-date", $event);
    },
    selectChangeTaker($event, changeIndex) {
      let changeList = this.changeList;
      changeList[changeIndex].taker = $event;
      this.$emit("taker-select", changeList);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/change-system-content-list-date";
</style>